module.exports = __webpack_public_path__ + "img/16.1-gallery.88da5579.jpg";